import React from 'react';

import PropTypes from 'prop-types';
import * as cn from 'classnames';

import { Text, Button } from 'modules/common';

import * as c from './constants';

function Note({
  title,
  description,
  type,
  buttonProps,
  leadingItem,
  descriptionClassName,
  withButton,
}) {
  const $type = c.TYPE_OPTS?.[type];
  const style = {
    background: $type?.background,
    border: $type?.border,
    text: $type?.text,
    buttonProps: $type?.buttonProps,
  };

  const leadingItemProps = {
    className: `${$type?.text} h-ds-16 w-ds-16`,
  };

  return (
    <div
      className={cn(
        'flex items-center rounded p-ds-8 gap-ds-8',
        style.background,
        style.border
      )}
    >
      {leadingItem ? (
        <>
          {typeof leadingItem === 'function'
            ? leadingItem(leadingItemProps)
            : leadingItem}
        </>
      ) : (
        <div className={cn(style.text)}>{c.warningIcon}</div>
      )}

      {title && (
        <Text type="overline" className={cn('uppercase', style.text)}>
          {title}
        </Text>
      )}

      {description && (
        <Text type="caption" className={cn('flex-1', descriptionClassName)}>
          {description}
        </Text>
      )}

      {withButton && (
        <Button
          label="View Issue"
          size="xs"
          {...style.buttonProps}
          {...buttonProps}
        />
      )}
    </div>
  );
}

Note.defaultProps = {
  type: 'default',
  buttonProps: {},
  title: '',
  description: '',
  descriptionClassName: '',
  leadingItem: false,
  withButton: true,
};

Note.propTypes = {
  type: PropTypes.oneOf(Object.keys(c.TYPE_OPTS)),
  buttonProps: PropTypes.instanceOf(Object),
  title: PropTypes.string,
  description: PropTypes.string,
  descriptionClassName: PropTypes.string,
  withButton: PropTypes.bool,
  leadingItem: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.element,
    PropTypes.string,
    PropTypes.instanceOf(Object),
    PropTypes.instanceOf(Function),
  ]),
};

export default Note;
